/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuDisplayPrefsSelect_filters$ref = any;
type SbSharedRefineMenuFilters_filters$ref = any;
export type SbRespRefineMenu_filters$ref = any;
export type SbRespRefineMenu_filters = ReadonlyArray<{
    readonly " $fragmentRefs": SbSharedRefineMenuFilters_filters$ref & SbSharedRefineMenuDisplayPrefsSelect_filters$ref;
    readonly " $refType": SbRespRefineMenu_filters$ref;
}>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenu_filters",
    "type": "SearchBrowseFilter",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuFilters_filters",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'fbe4a3afa9de14b2bf5167e3b6714133';
export default node;
